import Vue from 'vue';

import logging from "~/mixins/requestLogging";
import options from "~/mixins/options";
import files from "~/mixins/fileUpload";

Vue.mixin(logging);
Vue.mixin(options);
Vue.mixin(files);



// WEBPACK FOOTER //
// ./resources/js/mixins/index.js